<template>
  <div
    ref="node"
    :style="nodeContainerStyle"
    @click="clickNode"
    @mouseup="changeNodeSite"
    :class="nodeContainerClass"
  >
    <!-- 最左侧的那条竖线 -->
    <div
      class="ef-node-left"
      :style="node.type === 'is_end' ? 'background: red;' : ''"
    ></div>
    <div>
      <div style="display: flex; justify-content: start; align-items: center">
        <!-- 节点类型的图标 -->
        <div class="ef-node-left-ico flow-node-drag" :style="node.type === 'is_end' ? 'color: white' : ''">
          <i :class="nodeIcoClass"></i>
        </div>
        <!-- 节点名称 -->
        <div
          class="ef-node-text"
          :style="{
            color:
              node.type === 'is_judge' || node.type === 'is_end' ? 'white' : '',
          }"
          :show-overflow-tooltip="true"
        >
          {{ node.process_name }}
        </div>
      </div>
      <!-- 抄送、判断、结束节点不显示审批场景 -->
      <div
        style="display: flex; justify-content: start; align-items: center"
        v-if="node.type !== 'repeat_send' && node.type !== 'is_judge' && node.type !== 'is_end'"
      >
        <div class="ef-node-left-ico">
          <i class="el-icon-collection-tag"></i>
        </div>
        <div class="ef-node-text" :show-overflow-tooltip="true">
          {{ flow_app_text }}
        </div>
      </div>
      <!-- 判断、结束节点不显示人员类型 -->
      <div
        style="display: flex; justify-content: start; align-items: center"
        v-if="node.type !== 'is_judge' && node.type !== 'is_end'"
      >
        <div class="ef-node-left-ico">
          <i class="el-icon-star-on"></i>
        </div>
        <div class="ef-node-text" :show-overflow-tooltip="true">
          {{ signer_type }}
        </div>
      </div>
      <!-- 判断、结束节点不显示人员 -->
      <div
        style="display: flex; justify-content: start; align-items: center"
        v-if="
          node.type !== 'is_judge' &&
          node.type !== 'is_end' &&
          (node.auto_person === 1 ||
            node.auto_person === 2 ||
            node.auto_person === 3)
        "
      >
        <!-- 节点类型的图标 -->
        <div class="ef-node-left-ico">
          <i class="el-icon-user-solid"></i>
        </div>
        <!-- 节点名称 -->
        <div class="ef-node-text" :title="signer_name" :show-overflow-tooltip="true">
          {{ signer_name }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    node: {
      type: Object,
    },
    activeElement: {
      type: Object,
    },
    flow: {
      type: Object,
    },
  },
  data() {
    return {};
  },
  computed: {
    nodeContainerClass() {
      return {
        "ef-node-container": true,
        "ef-node-active":
          this.activeElement.type == "node"
            ? this.activeElement.nodeId === this.node.id
            : false,
      };
    },
    // 节点容器样式
    nodeContainerStyle() {
      let background = "white";
      this.node.type === "is_judge" && (background = "#1879FF");
      this.node.type === "is_end" && (background = "red");
      return {
        background,
        top: this.node.top,
        left: this.node.left,
      };
    },
    nodeIcoClass() {
      var nodeIcoClass = {};
      nodeIcoClass[this.node.ico] = true;
      // 添加该class可以推拽连线出来，viewOnly 可以控制节点是否运行编辑
      nodeIcoClass["flow-node-drag"] = this.node.viewOnly ? false : true;
      return nodeIcoClass;
    },
    flow_app_text() {
      let flow_app_text = "";
      this.node.flow_app === "agency" && (flow_app_text = "经销商");
      this.node.flow_app === "company" && (flow_app_text = "内部审批");
      return flow_app_text;
    },
    signer_type() {
      let signer_type = "";
      this.node.auto_person === 1 && (signer_type = "指定人员");
      this.node.auto_person === 2 && (signer_type = "指定角色");
      this.node.auto_person === 3 && (signer_type = "指定业务关联人员");
      return signer_type;
    },
    signer_name() {
      let signer_name = "";
      this.node.auto_person === 1 && (signer_name = this.node.user_text);
      this.node.auto_person === 2 && (signer_name = this.node.role_text);
      this.node.auto_person === 3 && (signer_name = this.node.work_text);
      return signer_name;
    },
  },
  methods: {
    // 点击节点
    clickNode() {
      this.$emit("clickNode", this.node.id);
    },
    // 鼠标移动后抬起
    changeNodeSite() {
      // 避免抖动
      if (
        this.node.left == this.$refs.node.style.left &&
        this.node.top == this.$refs.node.style.top
      ) {
        return;
      }
      this.$emit("changeNodeSite", {
        nodeId: this.node.id,
        left: this.$refs.node.style.left,
        top: this.$refs.node.style.top,
      });
    },
  },
};
</script>
